import React from 'react';
import { ChevronRight } from 'lucide-react';

const PATHWAY_ORDER = ['Modified', 'Junior Hardball', 'Senior Hardball'];
const COLORS = ['#2196F3', '#0B3D91', '#E31837'];

export default function PathwayFunnel({ data }) {
  const { pathway, unique_teams, unique_competitions } = data;
  if (!pathway || !pathway.length) return null;

  const ordered = PATHWAY_ORDER.map(type => {
    const found = pathway.find(p => p.type === type);
    return found || { type, competitions: 0 };
  });

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div className="section-title" data-testid="pathway-title">Cricket Development Pathway</div>
      <div className="glass-card" style={{ padding: '1.5rem' }}>
        <div className="pathway-funnel" data-testid="pathway-funnel">
          {ordered.map((step, i) => (
            <React.Fragment key={step.type}>
              {i > 0 && <div className="funnel-arrow"><ChevronRight size={24} /></div>}
              <div
                className="funnel-step"
                style={{ background: COLORS[i] }}
                data-testid={`funnel-step-${i}`}
              >
                <div className="funnel-step-value">{(step.competitions || 0).toLocaleString()}</div>
                <div className="funnel-step-label">{step.type}</div>
                <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.7)', marginTop: '0.2rem' }}>
                  team entries
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
        <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textAlign: 'center', marginTop: '0.75rem' }}>
          {(unique_teams || 0).toLocaleString()} unique teams across {(unique_competitions || 0).toLocaleString()} competitions &middot; Development pathway: Modified (Softball) &rarr; Junior Hardball &rarr; Senior Hardball
        </p>
      </div>
    </div>
  );
}
